<template>
    <div class="q-pa-md" >
        <div class="position-absolute" style="right: 15px;top:75px; z-index: 1">
            <div class="d-flex">
                <div @click="makeTransferDialog=true" class="export-button mr-3">
                    <q-tooltip>Stock Transfer</q-tooltip>
                    <div class="mt-1"><img alt="" src="../../assets/transfer.png"></div>
                </div>
                <q-input class="searchBox" debounce="500" placeholder="Search" style="width: 350px"
                         v-model="filter">
                    <template v-slot:prepend>
                        <q-icon name="search"/>
                    </template>
                </q-input>

            </div>
        </div>
        <q-tabs class="text-primary" align="left" style="padding-left: 16px;padding-right: 16px" v-model="tab">
            <q-tab :label="tab.label+' ('+tab.count+')'" :name="tab.component" :key="index"
                   class="text-blue" v-for="(tab, index) in vadTabArr"></q-tab>

        </q-tabs>
        <q-separator></q-separator>



        <transit-inventory :filter="filter" @ordersCount="vadTabArr[0].count=$event" ref="TransitInventory"
                           v-show="tab==='TransitInventory'"></transit-inventory>
        <sold-inventory :filter="filter" @ordersCount="vadTabArr[1].count=$event" ref="SoldInventory"
                        v-show="tab==='SoldInventory'"></sold-inventory>
        <paid-inventory-sales :filter="filter" @ordersCount="vadTabArr[2].count=$event" ref="PaidInventorySales"
                              v-show="tab==='PaidInventorySales'"></paid-inventory-sales>


        <q-dialog persistent position="right" v-model="makeTransferDialog">
            <stock-transfer @closeStockTransferDialog="makeTransferDialog=false"></stock-transfer>
        </q-dialog>
    </div>
</template>

<script>
    import TransitInventory from '../ManageStock/TransitInventory'
    import SoldInventory from '../ManageStock/SoldInventory'
    import PaidInventorySales from '../ManageStock/PaidInventorySales'
    import StockTransfer from '../StockTransfer'
    import Constants from '../../Constants/Constant'

    export default {
        name: 'Sales',
        components: {
            TransitInventory,
            SoldInventory,
            PaidInventorySales,
            StockTransfer,
        },
        data: function () {
            return {
                Constants: Constants,
                tab: 'TransitInventory',
                filter: '',
                vadTabArr: [
                    { label: 'Outgoing', component: 'TransitInventory', count: 0 },
                    { label: 'Sold', component: 'SoldInventory', count: 0 },
                    { label: 'Paid', component: 'PaidInventorySales', count: 0 }
                ],
                makeTransferDialog: false
            }
        },
        methods:{
            onWinScroll(){
                if ((window.innerHeight + window.scrollY + 80) >= document.body.offsetHeight) {
                    this.$refs[this.tab].fetchMoreOrders()
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.onWinScroll)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.onWinScroll)
        },
    }
</script>

<style scoped>

</style>
